import { CodeSet } from 'src/app/core/model/dictionary';

export class ChannelCategoryEdit
{
    public id = null;
    public name = '';
    public active = true;
    public channelWorkflowStatus: CodeSet;
}
